import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { PopupTriggerProps } from '@atlassian/jira-development-board-common/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './src/ui/__generated__/DeploymentDetailsPopupUiQuery$parameters';
import type { DeploymentDetailsPopupUiQuery } from './src/ui/__generated__/DeploymentDetailsPopupUiQuery.graphql';

export const deploymentDetailsEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			deployments: DeploymentDetailsPopupUiQuery;
		},
		{},
		PopupTriggerProps,
		{}
	>,
	{
		issueId: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-deployment-details-popup-new" */ './src/ui/DeploymentDetailsPopup.tsx'
			),
	),
	getPreloadProps: ({ issueId }: { issueId: string }) => ({
		queries: {
			deployments: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					issueAri: issueId,
				},
			},
		},
	}),
});
